import {
  GET_ANDROID_CLASSES_LIST,
  GET_ANDROID_CLASS_APPS, 
} from '../constants/acategory';

export const getAClassesList = param => ({
  type: GET_ANDROID_CLASSES_LIST,
  param,
});

export const getAClassApps = param => ({
  type: GET_ANDROID_CLASS_APPS,
  param,
});
